import React, { useState, useEffect, useRef } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import _ from 'lodash';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';

import SortFieldsDragDropKit from './SortFieldsDragDropKit';

import { getLocalizedFieldName } from '../../i18n';
import { handleColorSystem } from '../customComponent/colorSystem';
import theme from '../../theme';


const SortFields = (props) => {
  const {
    media,
    allfields,
    excelSheetSelected,
    updateSortFields,
    setUpdateSortFields,
    handleUpdateSortFields,
    reportLanguage
  } = props;

  const intl = useIntl();
  const [allSortFields, setAllSortFields] = useState([]);
  const [inputErrorMsg, setInputErrorMsg] = useState({ fieldName: '', expression: '' })
  const { colorSystem, mainColor, lightColor, darkColor, w01Color } = handleColorSystem(media);
  const [anchorEl, setAnchorEl] = useState(null);
  const popOpen = Boolean(anchorEl);

  const handleOpenSortPopover = (e) => {
    setAnchorEl(e.currentTarget);

    let fieldsToSort;

    if (media === 'FACEBOOK') {
      fieldsToSort = [...allfields];
    } else {
      // 從所有欄位中篩選出已勾選的欄位
      fieldsToSort = allfields.map((el) => {
        return {
          ...el,
          sheet: _.intersection(el.sheet, excelSheetSelected)
        };
      }).filter((item) => item.sheet.length !== 0);
    }

    const sortFields = fieldsToSort.sort((a, b) => {
      if (a.indexNumber === null) return 1;
      if (b.indexNumber === null) return -1;
      return a.indexNumber - b.indexNumber;
    });

    setAllSortFields(sortFields);   //拖曳中欄位
    setUpdateSortFields(sortFields);  //實際儲存的欄位
  }

  const handleCheckSortFields = () => {
    const sortFields = [...allSortFields];

    // 重新排序每個欄位的 index 值
    // const updateFields = sortFields.map((field, index) => ({
    //   ...field,
    //   indexNumber: index
    // }))

    setUpdateSortFields(sortFields);
    setInputErrorMsg('');
    setAnchorEl(null);
    handleUpdateSortFields(sortFields);
  }

  const handleCloseTrans = () => {
    setInputErrorMsg('');
    setAnchorEl(null);
    const origiFields = [...updateSortFields];
    setTimeout(() => {
      setAllSortFields(origiFields);
    }, 1000)
  }

  return (
    <>
      <Button
        onClick={handleOpenSortPopover}
        disabled={(!excelSheetSelected?.length || !allfields?.length) ? true : false}
        sx={{
          color: mainColor,
          padding: 0,
          '&:hover': { backgroundColor: '#fff' },
          '&:disabled': { color: theme.palette.grey.w400 }
        }}
      >
        <Typography variant="caption" >
          <FormattedMessage id="createData.button.sortField" />
        </Typography>
      </Button>
      {
        <Popover
          open={popOpen}
          anchorEl={anchorEl}
          onClose={handleCloseTrans}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <Box sx={{ height: '620px' }}>
            <Box
              sx={{
                position: 'relative',
                width: '350px',
                height: '550px',
                overflow: 'auto',
                padding: '16px',
              }}
            >
              <Typography variant='body2' mb={2} sx={{ color: mainColor }}>
                <FormattedMessage id="createData.field.sortFieldTip" />
              </Typography>

              <SortFieldsDragDropKit
                media={media}
                allSortFields={allSortFields}
                setAllSortFields={setAllSortFields}
                w01Color={w01Color}
                reportLanguage={reportLanguage}
                getLocalizedFieldName={getLocalizedFieldName}
                intl={intl}
              />

            </Box>

            <Box
              sx={{
                position: 'absolute',
                bottom: '16px',
                right: '16px',
                textAlign: 'end',
                marginTop: '12px'
              }}
            >
              <Button
                variant="text-cancel"
                sx={{ fontSize: '0.875rem' }}
                onClick={handleCloseTrans}
              >
                <FormattedMessage id="common.button.cancel" />
              </Button>

              <Button
                variant="fill-create"
                sx={{
                  color: '#fff',
                  fontSize: '0.875rem',
                  backgroundColor: mainColor,
                  '&:hover': {
                    backgroundColor: darkColor,
                  }
                }}
                onClick={handleCheckSortFields}
              >
                <FormattedMessage id="common.button.apply" />
              </Button>
            </Box>
          </Box>
        </Popover>
      }
    </>
  )
}

export default SortFields;